import { render } from "./DownloadFileCard.vue?vue&type=template&id=658fa6e4&scoped=true"
import script from "./DownloadFileCard.vue?vue&type=script&lang=js"
export * from "./DownloadFileCard.vue?vue&type=script&lang=js"

import "./DownloadFileCard.vue?vue&type=style&index=0&id=658fa6e4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658fa6e4"]])

export default __exports__